import React from "react";
import styled from "styled-components";

function About() {
  return (
    <Container>
    <section className="tc-about-style7">
      <div className="container">
        <div className="row gx-0 justify-content-between">
          <div className="col-lg-3">
            <div className="rotate-box" data-speed="1" data-lag="0.4">
              <div className="img shubh mt-lg-5">
                      <img
                        src="/home1/assets/img/team/berimg.jpg"
                        alt="Founder"
                        className="img-cover"
                      />
                      <div className="text fsz-25 fw-500 mt-2">
                <h2 className="text-center">Mudit Beri</h2>
                <h6 className="text-center">Founder</h6>
              </div>
                    </div>
            </div>
          </div>
          <div className="col-lg-7">
            <div className="info wow fadeInUp slow" data-wow-delay="0.2s">
              
              <div className="text fsz-25 fw-500 mb-20 mt-lg-5 mt">
              Meet Mudit Beri, the visionary founder of BDA, holding a passion for blending innovation and sustainability in his designs. With a degree from a prestigious architectural school, he’s quickly making a name for himself in the industry. He focuses on creating spaces that are not only aesthetically striking but also environmentally responsible.
              </div>
              <div className="text fsz-25 fw-500 mb-20">
              His work is defined by his dedication to incorporating green technologies, love for natural materials, and his meticulous attention to fine details. When he’s not sketching his next project, you can find him exploring urban landscapes, hiking in nature, or volunteering with local design initiatives. Driven by a vision of a more sustainable future, Mudit Beri is excited to redefine what it means to live and work in harmony with our environment.
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    </Container>
  );
}

export default About;

const Container = styled.div`
  .shubh {
    @media screen and (min-width: 992px) and (max-width: 1155px) {
      width: 400px;
      height: 500px;
    }
      @media screen and (min-width: 1156px) and (max-width: 2600px) {
      width: 400px;
      height: 500px;
    }
       @media screen and (min-width: 280px) and (max-width: 991px) {
      width: 260px;
      height: 330px;
    }
  }
    .mt {
    @media screen and (min-width: 280px) and (max-width: 991px) {
      margin-top: 9rem;
    }
    }
`;
